<template>
  <el-container :class="classObj" style="height: 100%" class="app-wrapper">
    <el-header>
      <Header />
    </el-header>
    <el-container class="container">
      <el-aside>
        <VehicleTree />
      </el-aside>
      <el-main style="height: 100%; background-color: #f4f8ff; text-align: left">
        <div style="position: relative">
          <tags-view />
        </div>
        <app-main />
      </el-main>
    </el-container>
    <el-dialog :title="drawerTitle" :visible.sync="drawer" width="80%" :before-close="handleCloseDrawer">
      <div>
        <SingleVehicleMsg :vehicleInfo="vehicleInfo" v-if="showSingleVehicleMsg" />
        <SingleVehicleTrack ref="SingleVehicleTrack" :vehicleInfo="vehicleInfo" v-if="showSingleVehicleTrack" />
        <SingleVehicleVedioMonitor v-if="showSingleVehicleVedioMonitor" :vehicleInfo="vehicleInfo" ref="vedioMonitor" />

      </div>

    </el-dialog>
    <!-- <el-drawer :title="drawerTitle" :visible.sync="drawer" direction="rtl" size="70%" :before-close="handleCloseDrawer">
     <SingleVehicleTrack v-if="showSingleVehicleTrack" :vehicleInfo="vehicleInfo" /> 
      <SingleVehicleVedioMonitor v-if="showSingleVehicleVedioMonitor" :vehicleInfo="vehicleInfo" ref="vedioMonitor" />
    </el-drawer>-->
    <!--  -->
  </el-container>
</template>

<script>
import TagsView from "./components/TagsView";
import Header from "./components/Header";
import VehicleTree from "./components/VehicleTree";
import AppMain from "./components/AppMain";
import SingleVehicleMsg from "@/components/SingleVehicleMsg";
import SingleVehicleTrack from "@/components/SingleVehicleTrack";
import SingleVehicleVedioMonitor from "@/components/SingleVehicleVedioMonitor";
import { queryVideoDeviceNoRecorder, queryVideoDeviceNo } from "@/http/vehicle";
import { mapState } from "vuex";
import settings from "@/settings";
export default {
  name: "Layout",
  components: {
    AppMain,
    VehicleTree,
    Header,
    TagsView,
    SingleVehicleTrack, SingleVehicleVedioMonitor, SingleVehicleMsg
  },
  data() {
    return {
      showDialog: true,
      drawer: false,
      showSingleVehicleMsg: false,
      showSingleVehicleTrack: false,
      drawerTitle: "",
      vehicleInfo: undefined,
      showSingleVehicleVedioMonitor: false,
    };
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      operator: (state) => state.user.operator,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
      };
    },
  },
  methods: {
    handleCloseDrawer() {
      if (this.showSingleVehicleVedioMonitor) {
        if (this.$refs.vedioMonitor)
          this.$refs.vedioMonitor.closeWin();
      }
      if (this.showSingleVehicleTrack) {
        if (this.$refs.SingleVehicleTrack)
          this.$refs.SingleVehicleTrack.destroy();
      }
      this.drawer = false;
      //取消播放器的资源
      // console.log("关闭");
    },
    async openRightDrawer(data) {


      console.log(data); // 打开抽屉
      this.showSingleVehicleTrack = false;
      this.showSingleVehicleVedioMonitor = false;
      this.showSingleVehicleMsg = false;


      if (data.command == "SingleVehicleTrack") {
        this.drawer = true;
        this.showSingleVehicleTrack = true;
        this.drawerTitle = data.vehicleInfo.vehicleName + "-" + this.$t('tree.今日轨迹');

        this.$nextTick(() => {
          if (this.$refs.SingleVehicleTrack)
            this.$refs.SingleVehicleTrack.show();
        });

      }
      if (data.command == "SingleVehicleVedioMonitor") {

        var res = await queryVideoDeviceNo({
          ManufactureID: data.vehicleInfo.manuID,
        });
        // console.log(res);
        if (res.code == 200 && res.data.length > 0 && res.data[0].DeviceNo != "") {

          this.drawer = true;
          this.showSingleVehicleVedioMonitor = true;
          this.drawerTitle = data.vehicleInfo.vehicleName + "-视频监控";
        }
        else {
          //提示，没有视频设备
          this.$message({
            message: this.$t( "tree.该车辆没有配置行驶记录仪设备,请联系销售人员"),
            type: "warning",
          })
        }

      }
      if (data.command == "SingleVehicleMsg") {
        //没有就不开弹框
        var res = await queryVideoDeviceNoRecorder({
          ManufactureID: data.vehicleInfo.manuID,
        });

        if (res.code == 200 && res.data.length > 0 && res.data[0].DeviceNo != "") {
          this.drawer = true;
          this.showSingleVehicleMsg = true;
          this.drawerTitle = data.vehicleInfo.vehicleName + "-消息发送";

        }
        else {
          //提示，没有视频设备
          this.$message({
            message: this.$t( "tree.该车辆没有配置行驶记录仪设备,请联系销售人员"),
            type: "warning",
          })
        }

      }
      this.vehicleInfo = data.vehicleInfo;

    },
  },
  created() {
    //当前域名+端口+指定路径 /socket
    var socketServer = window.location.origin + "/socket";
    //替换http为ws
    socketServer = socketServer.replace("http://", "").replace("https://", "");
//     //当前端口
//     var port = window.location.port;
// console.log(socketServer)
    //ws://localhost:8080/socket
    //注册websocket
    this.socketClient.init(
     settings.socketServer,
      80,
      //    this.operator.OperatorId
      parseInt(Math.random() * 100000000)
    );

    //开启左侧功能，
    this.$bus.$on("openRightDrawer", (data) => {
      this.openRightDrawer(data);
    });
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100%;
  width: 100%;

  .container {
    height: calc(100% - 90px);
  }

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }

  .el-aside {
    background-color: #e8f0ff;
  }

  .el-main {
    overflow: hidden;
  }
}

$sideBarWidth: 370px;

.fixed-header {
  position: fixed;
  top: 100px;
  right: 10px;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.el-header {
  padding: 0;
  width: 100%;
  height: 90px !important;
}

.openSidebar {
  .el-aside {
    width: 300px !important;   
  }
}

.hideSidebar {
  .el-aside {
    width: 45px !important;
  }
}
</style>
